import React, { useEffect } from "react";
import Header from "./Header";
import Join from "../../Join";
import Footer from "../../Footer";

const Supports1 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <Header />
      <Join />
      <Footer />
    </>
  );
};

export default Supports1;
